// Bongasoft API path constants.
// axios baseURL is `${REACT_APP_SERVER_URL}api/` → e.g. https://edge.bongasoft.com/api/
// so every constant here is relative to that base (resolves under /api/...).
//
// Services (by path prefix, all behind edge.bongasoft.com):
//   user      → auth/** · users/** · companies/** · roles/**
//   contacts  → contacts/**
//   messaging → sms/** · messaging/me/**
//   billing   → billing/**

// ───────────────────────── user-service: auth ─────────────────────────
export const POST_LOGIN = "auth/login";
export const POST_REFRESH_TOKEN = "auth/refresh";            // ?refreshToken=
export const POST_LOGOUT = "auth/logout";                    // ?token=
export const POST_PASSWORD_FORGET = "auth/forgot-password";
export const POST_RESET_PASSWORD = "auth/reset-password";
export const POST_CHANGE_PASSWORD = "users/change-password";

// ───────────────────────── user-service: profile / users ──────────────
export const GET_ME = "users/me";
export const GET_MY_PERMISSIONS = "users/me/permissions";
export const GET_TENANT_CONFIG = "users/me/tenant-config";
export const USER_BY_ID = "users";                            // PUT users/{id}
export const COMPANY_USERS = "companies";                     // companies/{companyId}/users[...]
export const GET_ROLES = "roles";
export const GET_PERMISSION_CATALOG = "roles/permissions";

// ───────────────────────── contacts-service ───────────────────────────
export const CONTACT_LISTS = "contacts/lists";               // GET list / POST create / {id}
export const CONTACTS = "contacts";                          // contacts/{id}, contacts/{id}/lists, contacts/{id}/expiry
export const CONTACTS_BY_MOBILE = "contacts/mobile";         // contacts/mobile/{mobile}[/lists]
export const CONTACT_EXPORTS = "contacts/exports";           // POST {scope,listId,format}
export const CONTACT_IMPORTS = "contacts/imports";           // POST upload → /{id}/mapping → /{id}/commit
export const CONTACT_BULK = "contacts/bulk";                 // POST JSON bulk create
export const CONTACT_USER_LISTS = "contacts/users";          // contacts/users/{userId}/lists (group-lead ACL)
export const CONTACT_DNC = "contacts/dnc";

// ───────────────────────── messaging-service ──────────────────────────
export const SMS_SINGLE = "sms/single";
export const SMS_BULK = "sms/bulk";
export const SMS_SCHEDULED = "sms/scheduled";                // POST schedule / GET list / {id} / {id}/messages
export const SMS_BATCH = "sms/batch";                        // sms/batch/{id}/summary · /{id}/messages · /summaries
export const SMS_BATCH_SUMMARIES = "sms/batch/summaries";
export const MESSAGING_KEYWORDS = "messaging/me/keywords";   // sender assignments (replaces /user/short_code)
export const STATS_SNAPSHOT = "messaging/me/stats/snapshot";
export const STATS_SMS_TIMESERIES = "messaging/me/stats/sms/timeseries";

// ───────────────────────── billing-service ────────────────────────────
export const BILLING_ACCOUNT = "billing/account";            // ?country= → balance + activeUnitsAvailable
export const BILLING_BATCHES = "billing/account/batches";    // ?country=&status=ACTIVE
export const BILLING_LEDGER = "billing/account/ledger";
export const BILLING_UNIT_HISTORY = "billing/account/unit-history";
export const BILLING_COST_ESTIMATE = "billing/account/cost-estimate";
export const BILLING_CDRS = "billing/cdrs";
export const BILLING_TOPUP = "billing/top-up";
export const BILLING_RECEIPTS = "billing/receipts";
export const BILLING_SUBSCRIPTIONS = "billing/subscriptions";

// ─────────────────────────────────────────────────────────────────────
// LEGACY constants — still referenced by not-yet-migrated live helpers
// (config_helper, contact_list_helper, bulk_list_helper → Phases 2/3) and
// by dead template code (fakebackend_helper, AuthType/fakeBackend,
// dashboard-blog, register → removed in Phase 5). DO NOT use in new code.
// Remove this whole block once Phases 2/3/5 land.
// ─────────────────────────────────────────────────────────────────────
export const POST_FAKE_REGISTER = "/post-fake-register";
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/forgetpassword";
export const SOCIAL_LOGIN = "/social-login";
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";
export const USER_PROFILE_DATA = "/user";
export const GET_WEEKLY_DATA = "/weekly-data";
export const GET_YEARLY_DATA = "/yearly-data";
export const GET_MONTHLY_DATA = "/sms/daily_report/graph";
export const GET_VISITOR_DATA = "/visitor-data";
export const GET_CONTACT_LIST_DATA = "/contact_list";
export const GET_USERS_LIST_DATA = "/user/child_users";
export const GET_BULK_LIST_DATA = "/bulk_sms/schedule";
export const GET_BULK_DELIVERY_DATA = "/bulksms/delivery_reports";
export const SEND_QUICK_SMS = "/send_sms/single";
export const GET_SHORTCODES_DATA = "/user/short_code";
